import { type ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import KpisGoalsTableTab from './tabs/KpisGoalsTableTab';
import KpisGoalsValuesTableTab from './tabs/KpisGoalsValuesTableTab';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'goals',
		title: 'TAB_KPIS_GOALS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'sys_kpis_goals'),
		content: props => <KpisGoalsTableTab {...props} />
	},
	{
		id: 'goals-values',
		title: 'TAB_KPIS_GOALS_VALUES',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'sys_kpis_goals'),
		content: props => <KpisGoalsValuesTableTab {...props} />
	}
];

export default tabs;
